import {connect} from 'react-redux';
import FeeDetail from './FeeDetail.jsx';
import {handleTournamentTechFeeEditClick} from './actions';

const mapStateToProps = (state, props) => {
  return ({ 
    ...props,
    defaultTechnologyFee: state.finance.fees.feesList.defaultTechnologyFee
  });
};

const mapDispatchToProps = dispatch => ({ 
  onEditTournamentTechFeeClick: (tournamentId) => dispatch(handleTournamentTechFeeEditClick(tournamentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(FeeDetail);



// WEBPACK FOOTER //
// ./src/features/finance/fees/FeeDetailContainer.jsx